import {IPolicy } from "./PA.Core.IF.Policy";
import {IMessageProvider, IProgressProvider} from "./PA.Core.IF.Basic";
import {
  WB_UserReviewerRow,
  WB_UserRow,
  WB_WorflowStatusHistoryRow,
  WB_WorkflowRow,
  WB_WorkflowStatusRow
} from "./PAdbSchemaRows";
import {IBusinessObject} from "./PA.Core.IF.BO";
import {IwbUserReviewer} from "./PAdbSchemaRowsIF";
import {PAdbContext} from "./PAdbContext";

export enum ApprovalType {
  Payment = 'Payment',
  Event = 'Event',
  EventSpend = 'EventSpend'
}

export enum ApprovalSubType {
  SpendAmt = 'SpendAmt',
  SpendRate = 'SpendRate',
  Threshold = 'Threshold'
}

export enum ApprovalRangeBoundsType {
  CustomerActualSpend = 'CustomerActualSpend',
  PaymentActualSpend = 'PaymentActualSpend',
  PlannedSpend = 'PlannedSpend',
  LESpend = 'LESpend',
  AbsoluteRateLimit = 'AbsoluteRateLimit'
}

export enum ApprovalAction {
  None = 'None',
  RaiseWarning = 'RaiseWarning',
  RaiseError = 'RaiseError',
  RaiseErrorIfApproved = 'RaiseErrorIfApproved',
  RequireApprovalRole = 'RequireApprovalRole'
}


export enum StatusType {
  Initial =  'Initial',
  PendingApproval = 'PendingApproval',
  Rejected = 'Rejected',
  Approved = 'Approved',
  Revised = 'Revised',
  RevisionsDenied = 'RevisionsDenied',
  Cancelled = 'Cancelled',
  Closed = 'Closed'
}

export enum ApproverPolicy {
  None = "None",
  ApproverList = "ApproverList",
  ReviewerList = "ReviewerList"
}

export interface IHaveWorkflow {
  readonly WorkflowProcessors: IWorkflowProcessor[]
  readonly PrimaryWorkflowProcessor: IWorkflowProcessor
}

export interface setStateOptions {
  bStatusLogHistory?: boolean
}

export interface IWorkflowPolicyFields {
  WorkflowVisible?: boolean
  CurrentStateVisible?: boolean
  NextStateEditable?: boolean
  NextStateVisible?: boolean,

  // enabled / disables WP behaviors
  ValidateEnabled?: boolean,
  SaveEnabled?: boolean,
  OnSavedEnabled?: boolean,

  bNotify?: boolean
}

export interface IWorkflowValidateOptions {
  [id:string]: any
}

export interface IWorkflowValidateTransitionOptions extends IWorkflowValidateOptions {
  UsingNextStateType?: StatusType
  UsingNextState?: WB_WorkflowStatusRow
  [id:string]: any
}


export interface IWorkflowProcessor
extends IPolicy
{

  setExtensions(arrExt: IWorkflowProcessorExtension[]): void
  readonly OnLoadComplete: Promise<void>
  readonly dbContext: PAdbContext

  readonly WorkflowProgressProvider: IProgressProvider
  readonly WorkflowMessageProvider: IMessageProvider
  readonly WorkflowId: number
  readonly Workflow: WB_WorkflowRow
  readonly WorkflowVisible: boolean

  Validate(options?: IWorkflowValidateOptions): Promise<void>
  ValidateTransition(options?: IWorkflowValidateTransitionOptions): Promise<void>
  readonly ValidateEnabled: boolean

  Save(bUseBatch?: boolean, options?: any): Promise<void>
  readonly SaveEnabled: boolean

  OnSaved(options?: any): Promise<void>
  readonly OnSavedEnabled: boolean

  OnReloaded(): Promise<void>

  getStateType(sStateType: string): WB_WorkflowStatusRow | WB_WorkflowStatusRow[]
  setStateType(sCurrStateType?: string, sNextStateType?: string, options?: setStateOptions): Promise<void>
  setState(iCurrStateId?: number, iNextStateId?: number, options?: setStateOptions): Promise<void>

  setPolicyFields(opts: IWorkflowPolicyFields): void
  getPolicyFields(): IWorkflowPolicyFields

  clearStatusHistoryLog(): void
  addStatusHistoryLogMessage(sCode: string, sMessage:string): void
  removeStatusHistoryLogMessage(sCode:string): void

  readonly CurrentStateId: number
  readonly CurrentState: WB_WorkflowStatusRow
  readonly CurrentStateVisible: boolean

  readonly NextStateEditable: boolean
  readonly NextStateVisible: boolean
  readonly NextStates: WB_WorkflowStatusRow[]
  NextStateId: number
  readonly NextState: WB_WorkflowStatusRow



  NextUserId: number
  readonly NextUser: WB_UserRow

  readonly WorkflowStatusHistory: WB_WorflowStatusHistoryRow[]

  readonly bApproverRequired: boolean

  readonly bUseApproverList:boolean
  readonly ApproverList: WB_UserRow[]


  readonly bUseReviewerList:boolean
  readonly UserReviewerList: WB_UserReviewerRow[]


}


export interface IWorkflowProcessorExtension {

  id: string
  OnLoad?: (aWfProcessor: IWorkflowProcessor) => Promise<void>

  GetApproverPolicy: (aWfProcessor: IWorkflowProcessor) => Promise<ApproverPolicy>
  GetApproverList?: (aWfProcessor: IWorkflowProcessor, options?: any) => Promise<WB_UserRow[]>

  SyncReviewerListBefore?: (aWfProcessor: IWorkflowProcessor) => Promise<void>
  SyncReviewerList?: (aWfProcessor: IWorkflowProcessor) => Promise<void>
  SyncReviewerListAfter?: (aWfProcessor: IWorkflowProcessor) => Promise<void>

  ValidateBefore?: (aWfProcessor: IWorkflowProcessor, options?: IWorkflowValidateTransitionOptions) => Promise<void>
  Validate?: (aWfProcessor: IWorkflowProcessor, options?: IWorkflowValidateTransitionOptions) => Promise<void>
  ValidateAfter?: (aWfProcessor: IWorkflowProcessor, options?: IWorkflowValidateTransitionOptions) => Promise<void>

  OnValidatationSucessBefore?: (aWfProcessor: IWorkflowProcessor, options?: IWorkflowValidateOptions) => Promise<void>
  OnValidatationSucess?: (aWfProcessor: IWorkflowProcessor, options?: IWorkflowValidateOptions) => Promise<void>
  OnValidatationSucessAfter?: (aWfProcessor: IWorkflowProcessor, options?: IWorkflowValidateOptions) => Promise<void>
  LogTransitionCondition?: (aWfProcessor: IWorkflowProcessor) => boolean

  Save?: (aWfProcessor: IWorkflowProcessor, bUseBatch?: boolean, options?: any) => Promise<void>

  OnSavedBefore?: (aWfProcessor: IWorkflowProcessor, options?: any) => Promise<void>
  OnSaved?: (aWfProcessor: IWorkflowProcessor, options?: any) => Promise<void>
  OnSavedAfter?: (aWfProcessor: IWorkflowProcessor, options?: any) => Promise<void>

  OnReloadedBefore?: (aWfProcessor: IWorkflowProcessor) => Promise<void>
  OnReloaded?: (aWfProcessor: IWorkflowProcessor) => Promise<void>
  OnReloadedAfter?: (aWfProcessor: IWorkflowProcessor) => Promise<void>

}

